<p>
  หากไม่ดาวน์โหลด ลองกด
  <button class="btn btn-link" (click)="ngOnInit()">ที่นี่</button>
  อีกครั้ง
</p>



// WEBPACK FOOTER //
// ./src/app/download-file/download-file.component.html